// frontend/src/config.js
// Created: March 20, 2025

// Centralized configuration file

// API URL configuration
export const API_URL = 'https://api.annuityleadsforagents.com';
  
// JWT token settings
export const TOKEN_SETTINGS = {
    storageKey: 'token',
    userStorageKey: 'user',
    refreshThreshold: 30 * 60 * 1000, // 30 minutes before expiry
};
  
// App settings
export const APP_SETTINGS = {
    name: 'Annuity Leads For Agents',
    website: 'https://www.annuityleadsforagents.com',
    supportEmail: 'support@annuityleadsforagents.com',
    sessionTimeout: 30 * 60 * 1000, // 30 minutes inactivity timeout
    sessionWarningTime: 25 * 60 * 1000, // Warning at 25 minutes
};
  
// Unbounce settings
export const UNBOUNCE_SETTINGS = {
    targetAccountId: '5647106',
    callbackUrl: 'https://api.annuityleadsforagents.com/oauth/callback',
    authEndpoint: 'https://api.unbounce.com/oauth/authorize',
    clientId: 'e62875cbd9c3840cf49e832c4e69fe80726550709672ed413fce84c466c97b5b'
};